import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import type { SxProps } from '@mui/system';
import { generateRandomString } from 'common/utilities/core/string';
import type * as I from 'core/api/coreApiClient';
import { inputStyles } from 'core/utilities/styles/input.styles';
import theme, { sx, ThemeVars } from 'core/utilities/theme';
import type React from 'react';
import { useState } from 'react';

export const sideLabelStyles: SxProps = {
  width: ThemeVars.sideLabelWidth,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 500,
  textAlign: 'right',
  paddingRight: theme.spacing(3),
};

interface ComponentProps {
  htmlFor?: string;
  /** Show the label on the left side of the form element */
  sideLabel?: boolean;
  errorMsg?: I.Message[];
  disabled?: boolean;
  label: string | JSX.Element;
  children: React.ReactNode;
  required?: boolean;
  testid?: string;
  title?: string;
  inTable?: boolean;
  inputFileLabel?: boolean;
}

function InputDynamicLabel({
  sideLabel, errorMsg, disabled, htmlFor, label, children, required, testid, title, inTable,
  inputFileLabel,
}: ComponentProps) {
  const styles = inputStyles({
    longFormStyle: true, sideLabel, errorMsg, inTable,
  });
  const [id] = useState(() => generateRandomString());

  return (
    <Box
      display={sideLabel ? 'flex' : 'block'}
      alignItems={sideLabel ? 'flex-start' : undefined}
      role="group"
      aria-labelledby={id}
      data-testid={testid}
      sx={sx(
        styles.root,
        inputFileLabel && inTable ? { mt: -2.5, mb: 0.5 } : undefined,
      )}
    >
      {sideLabel && (
        <InputLabel
          id={id}
          sx={sx(sideLabelStyles, { marginTop: '10px' })}
          htmlFor={htmlFor}
          error={errorMsg && errorMsg.length > 0}
          disabled={disabled}
          required={required}
          title={title}
        >
          {label}
        </InputLabel>
      )}
      {children}
    </Box>
  );
}

export default InputDynamicLabel;
